// Segmented control. This markup was hand-rolled three times in this module
// (ImportDataPage, DataMappingPage, and the since-removed ImportHistoryPage) with
// slightly different padding each time; it is one component now, on the shared
// .o-toggle vocabulary.

export default function SubTabs({ tabs, active, onChange }) {
  return (
    <div className="o-toggle" style={{ marginBottom: 20 }}>
      {tabs.map(t => (
        <button
          key={t.id}
          type="button"
          aria-selected={active === t.id}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
